<template>
 	<b-container id="bills-create" fluid>
        <b-row class="page-title">
            <b-container fluid>
                <b-row>
                    <b-col cols="7">
                        <h3>Bills - Create</h3>
                    </b-col>
                    <b-col cols="2" class="text-right">
                        <b-form inline>
                            <label class="mr-sm-2" for="inline-form-select-wh">Location</label>
                            <b-form-select id="inline-form-select-wh" class="mb-2 mr-sm-2 mb-sm-0" v-model="datasets.core.location" :options="datasets.locations" size="sm"></b-form-select>
                        </b-form>
                    </b-col>
                    <b-col cols="2" class="text-right">
                        <b-form inline>
                            <label class="mr-sm-2" for="inline-form-select-status">Status</label>
                            <b-form-select id="inline-form-select-status" class="mb-2 mr-sm-2 mb-sm-0" v-model="datasets.core.status" :options="datasets.statuses" size="sm"></b-form-select>
                        </b-form>
                    </b-col>
                    <b-col cols="1">
                        <b-button type="submit" variant="success" @click="create" class="btn-sm" :disabled="!datasets.core.vendor">
                            <span v-if="submitting">
                                <b-spinner small type="grow"></b-spinner>
                                Creating...
                            </span>
                            <span v-else>Create</span>
                        </b-button>
                    </b-col>
                </b-row>
                <hr />
            </b-container>
        </b-row>
        <b-row :key="pageKey">
            <b-col cols="7">
                <b-form-row>
                    <b-col>
                        <b-form-group
                            id="datepicker-group-date"
                            label="Date:"
                            label-for="datepicker-date"
                            label-size="sm"
                        >
                            <b-form-datepicker
                                id="datepicker-date"
                                v-model="datasets.core.date"
                                class="mb-2"
                                size="sm"
                                :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                locale="en"
                            >
                            </b-form-datepicker>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group
                            id="input-group-vendor"
                            label="Vendor:"
                            label-for="input-vendor"
                            label-size="sm"
                        >
                            <div class="options-assign">
                                <div class="autosuggest-container">
                                    <vue-autosuggest
                                        v-model="datasets.core.vendor"
                                        :suggestions="autosuggest.vendor.suggestions"
                                        @click="clickHandlerVendor"
                                        @input="fetchResultsVendor"
                                        @selected="onSelectedVendor"
                                        @keydown.tab="suggestFirstVendor($event.target.value)"
                                        :get-suggestion-value="getSuggestionValueVendor"
                                        :input-props="{id:'autosuggest__input', placeholder:''}"
                                        @keyup.enter="suggestFirstVendor($event.target.value)"
                                        @change="vendorChanged(0)"
                                    >
                                        <b-container slot-scope="{suggestion}" fluid>
                                            <b-row>
                                                <b-col class="text-right">
                                                    {{ suggestion.item.name }}
                                                </b-col>
                                            </b-row>
                                        </b-container>
                                    </vue-autosuggest>
                                </div>
                            </div>
                        </b-form-group>
                    </b-col>
                </b-form-row>
                <b-form-row>
                    <b-col>
                        <b-form-group
                            id="input-group-email"
                            label="Email:"
                            label-for="input-email"
                            label-size="sm"
                        >
                            <b-form-input
                                id="input-email"
                                v-model="datasets.core.email"
                                type="text"
                                size="sm"
                                autocomplete="off"
                                @change="vendorChanged(1)"
                            >
                            </b-form-input>
                            <!-- <b-form-checkbox
                                id="checkbox-1"
                                name="checkbox-1"
                                value="accepted"
                                v-model="datasets.core.emailSend"
                                unchecked-value="not_accepted"
                                size="sm"
                            >
                                Send copy
                            </b-form-checkbox> -->
                        </b-form-group>
                    </b-col>
                    <b-col cols="3">
                        <b-form-group
                            id="input-group-phone"
                            label="Phone:"
                            label-for="input-phone"
                            label-size="sm"
                        >
                            <b-form-input
                                id="input-phone"
                                v-model="datasets.core.phone"
                                type="text"
                                size="sm"
                                autocomplete="off"
                                @change="vendorChanged(1)"
                            >
                            </b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="3">
                        <b-form-group
                            id="input-group-fax"
                            label="Fax:"
                            label-for="input-fax"
                            label-size="sm"
                        >
                            <b-form-input
                                id="input-fax"
                                v-model="datasets.core.fax"
                                type="text"
                                size="sm"
                                autocomplete="off"
                                @change="vendorChanged(1)"
                            >
                            </b-form-input>
                        </b-form-group>
                    </b-col>
                </b-form-row>
                <b-form-row>
                    <b-col cols="2">
                        <b-form-checkbox
                            id="checkbox-1"
                            name="checkbox-1"
                            value="1"
                            v-model="datasets.core.emailSend"
                            unchecked-value="0"
                            size="sm"
                        >
                            Send copy
                        </b-form-checkbox>
                    </b-col>
                    <b-col cols="6">
                        <b-form-group
                            id="input-group-tags"
                            label="Tags:"
                            label-for="input-tags"
                            label-size="sm"
                        >
                            <vue-tags-input
                                v-model="tags.currentTag"
                                :tags="datasets.core.tags"
                                :autocomplete-items="filteredTags"
                                @tags-changed="newTags => datasets.core.tags = newTags"
                                placeholder=""
                            />
                        </b-form-group>
                    </b-col>
                    <b-col cols="4">
                        <b-form-group
                            id="input-group-reference"
                            label="Reference:"
                            label-for="input-reference"
                            label-size="sm"
                        >
                            <b-form-input
                                id="input-reference"
                                v-model="datasets.core.reference"
                                type="text"
                                size="sm"
                                autocomplete="off"
                            >
                            </b-form-input>
                        </b-form-group>
                    </b-col>
                </b-form-row>
            </b-col>
            <b-col cols="5">
                <b-form-row>
                    <b-col>
                        <b-form-group
                            id="select-group-bills-shipping-method"
                            label="Shipping Method:"
                            label-for="select-shipping-method"
                            label-size="sm"
                        >
                            <b-form-select v-model="datasets.core.shippingMethod" :options="datasets.shippingMethods" size="sm" @change="vendorChanged(1)"></b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group
                            id="select-group-bills-payment-method"
                            label="Payment Terms:"
                            label-for="select-payment-method"
                            label-size="sm"
                        >
                            <b-form-select v-model="datasets.core.paymentTerm" :options="datasets.paymentTerms" size="sm" @change="vendorChanged(1)"></b-form-select>
                        </b-form-group>
                    </b-col>
                </b-form-row>
                <b-form-row>
                    <b-col @click="openModal('edit-billing')">
                        <b-form-group
                            id="textarea-group-billing-address"
                            label="Billing Address:"
                            label-for="textarea-billing-address"
                            label-size="sm"
                        >
                            <b-form-textarea
                                id="textarea-billing-address"
                                v-model="datasets.core.billingAddressBlock"
                                placeholder=""
                                rows="5"
                                size="sm"
                                no-resize
                                disabled
                            ></b-form-textarea>
                        </b-form-group>
                    </b-col>
                    <b-col @click="openModal('edit-shipping')">
                        <b-form-group
                            id="textarea-group-shipping-address"
                            label="Shipping Address:"
                            label-for="textarea-shipping-address"
                            label-size="sm"
                        >
                            <b-form-textarea
                                id="textarea-shipping-address"
                                v-model="datasets.core.shippingAddressBlock"
                                placeholder=""
                                rows="5"
                                size="sm"
                                no-resize
                                disabled
                            ></b-form-textarea>
                        </b-form-group>
                    </b-col>
                </b-form-row>
            </b-col>
        </b-row>
        <b-row>
            <b-container fluid>
                <b-table-simple hover small responsive bordered sticky-header="430px">
                    <b-thead>
                        <b-tr>
                            <b-th class="text-center th-number">#</b-th>
                            <b-th></b-th>
                            <b-th>Title</b-th>
                            <b-th>SKU</b-th>
                            <b-th>MPN</b-th>
                            <b-th class="text-center">QTY</b-th>
                            <b-th class="text-center">Cost</b-th>
                            <b-th class="text-center">Total</b-th>
                            <b-th>Notes</b-th>
                            <b-th></b-th>
                        </b-tr>
                    </b-thead>
                    <b-tbody>
                        <b-tr v-for="(item, index) in datasets.rows" :key="index" :class="`index-${index}`">
                            <td class="text-center">
                                {{ index + 1 }}
                            </td>
                            <td class="text-center">
                                <b-img-lazy v-if="item.url" class="products-thumbs" :src="item.url"></b-img-lazy>
                            </td>
                            <td>
                                <b-form-input v-model="datasets.rows[index].description" size="sm" class="text-center" :ref="'titleinput' + index" @keyup.13="nextRow(index, 'title')" @focus="focusMeRow(index)" vf-b-tooltip.hover :title="datasets.rows[index].description" disabled></b-form-input>
                            </td>
                            <td>
                                <autosuggest-instance
                                    :key="index"
                                    :idx="index"
                                    @nextRow="nextRow"
                                    @suggestFirstRow="suggestFirstRow"
                                    @onSelectedRow="onSelectedRow"
                                    @focusMeRow="focusMeRow(index)"
                                    :ref="'skuinput' + index"
                                />
                            </td>
							<td>
                                <b-form-input v-model="datasets.rows[index].mpn" size="sm" class="text-center" :ref="'mpninput' + index" @keyup.13="nextRow(index, 'mpn')" @focus="focusMeRow(index)"></b-form-input>
                            </td>
                            <td>
                                <b-form-input v-model="datasets.rows[index].qty" size="sm" class="text-center" @input="calculateRow(index)" :ref="'qtyinput' + index" @keyup.13="nextRow(index, 'qty')" @focus="focusMeRow(index)"></b-form-input>
                                <div class="text-center">
                                    QOO: <span v-if="item.qoo">{{ item.qoo || 0 }}</span><span v-else>0</span><br />
                                    Available: <span v-if="item.available">{{ item.available || 0 }}</span><span v-else>0</span><br />
                                </div>
                            </td>
                            <td>
                                <b-form-input v-model="datasets.rows[index].cost" size="sm" class="text-center" data-price-math="1" @keydown.native="allowPriceMathKeydown" @input="onPriceMathModelInput($event, index, 'cost'); calculateRow(index)" :ref="'rateinput' + index" @paste.native="onPriceMathPaste($event, index, 'cost')" @blur.native="handlePriceFieldBlur($event, index, 'cost')" @keyup.13.native="handlePriceFieldEnter($event, index, 'cost', 'rate')" @focus="focusMeRow(index)"></b-form-input>
                                <div class="text-center">
                                    Last Cost: $<span v-if="item.lastCost">{{ numberWithCommas(item.lastCost) || '0.00' }}</span><span v-else>0</span><br />
                                    Avg Cost:
                                </div>
                            </td>
                            <td>
                                <b-form-input v-model="datasets.rows[index].amount" size="sm" class="text-center" disabled></b-form-input>
                                <div class="text-center">
                                    GP: $<span v-if="item.rate && item.cost && item.qty">{{ numberWithCommas(((item.rate - item.cost) * item.qty)) || '0.00' }}</span><span v-else>0.00</span>
                                </div>
                            </td>
                            <td>
                                 <b-form-input v-model="datasets.rows[index].notes" size="sm" class="text-center" :ref="'notesinput' + index" @keyup.13="nextRow(index, 'notes')" @focus="focusMeRow(index)"></b-form-input>
                            </td>
                            <td class="text-center"><b-button size="sm" variant="danger" @click="deleteRow(index)"><i class="far fa-trash-alt"></i></b-button></td>
                        </b-tr>
                    </b-tbody>
                </b-table-simple>
                <b-row>
                    <b-col cols="1">
                        <b-button size="sm" @click="addTenRows"><i class="fas fa-plus"></i> 10</b-button>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="4">
                        <b-row>
                            <b-col cols="12">
                                <b-form-group
                                    id="textarea-group-order-notes"
                                    label="Notes:"
                                    label-for="textarea-order-notes"
                                    label-size="sm"
                                >
                                    <b-form-textarea
                                        id="textarea-order-notes"
                                        v-model="datasets.core.internalNote"
                                        placeholder=""
                                        rows="8"
                                        size="sm"
                                        no-resize
                                    ></b-form-textarea>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="8" class="text-right">
                        <b-table-simple hover small responsive>
                            <b-tbody>
                                <b-tr>
									<b-td></b-td>
                                    <b-td class="table-totals-col"><strong>Subtotal:</strong></b-td>
                                    <b-td class="table-totals-col">${{ numberWithCommas(datasets.core.subtotal) || '0.00' }}</b-td>
                                </b-tr>
                                <b-tr>
									<b-td><b-form-input v-model="datasets.core.shippingNotes" size="sm"></b-form-input></b-td>
                                    <b-td><strong>Shipping:</strong></b-td>
                                    <b-td><b-form-input v-model="datasets.core.shippingAmount" size="sm" class="text-right" @input="calculateTotals()"></b-form-input></b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td><b-form-input v-model="datasets.core.creditNotes" size="sm"></b-form-input></b-td>
                                    <b-td><strong>Credits:</strong></b-td>
                                    <b-td><b-form-input v-model="datasets.core.creditAmount" size="sm" class="text-right" @input="calculateTotals()"></b-form-input></b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td></b-td>
                                    <b-td><strong>Total:</strong></b-td>
                                    <b-td>${{ numberWithCommas(datasets.core.total) || '0.00' }}</b-td>
                                </b-tr>
                            </b-tbody>
                        </b-table-simple>
                    </b-col>
                </b-row>
                <modal-edit-shipping
                    v-if="modals['modal-orders-bills-edit-shipping'].active"
                    :address="datasets.core.shippingAddress"
                    @updateAddress="updateAddress"
                />
                <modal-edit-billing
                    v-if="modals['modal-orders-bills-edit-billing'].active"
                    :address="datasets.core.billingAddress"
                    @updateAddress="updateAddress"
                />
            </b-container>
        </b-row>
    </b-container>
</template>
<script>
    import { VueAutosuggest } from "vue-autosuggest"
    import AutosuggestInstance from '../../../../pages/user/inventory/products/AutosuggestInstance'
    import VueTagsInput from '@johmun/vue-tags-input'
    import ModalEditBilling from './modals/EditBilling'
    import ModalEditShipping from './modals/EditShipping'
    import priceMathInput from '../../../../mixins/priceMathInput'
    import { fetchActivePaymentTerms } from '../../../../utils/paymentTerms'
    import { fetchActiveShippingMethods } from '../../../../utils/shippingMethods'
 	export default {
    	name: 'BillsCreate',

        mixins: [priceMathInput],

        metaInfo() {
            return {
                title: 'Bill - Create',
            }
        },

    	components: {
            VueAutosuggest,
            AutosuggestInstance,
            VueTagsInput,
            'modal-edit-billing': ModalEditBilling,
            'modal-edit-shipping': ModalEditShipping
    	},
        data() {
            return {
                vendorReset: 0,
                vendorUpdated: 0,
                datasets: {
                    location: [],
                    core: {
                        date: this.getDate(),
                        shippingAddress: [],
                        billingAddress: [],
                        emailSend: 0,
                        shippingNotes: '',
                        shippingAmount: 0,
                        creditNotes: '',
                        creditAmount: 0,
                        status: 'Pending',
                        tags: [],
                        location: 'BSG'
                    },
                    rows: [],
                    shippingMethods: [],
                    paymentTerms: [],
                    statuses: [
                        'Pending',
                        'Confirmed'
                    ]
                },
                tags: {
                    list: [],
                    currentTag: ''
                },
                autosuggest: {
                    vendor: {
                        suggestions: [],
                        debounceMilliseconds: 500,
                        timeout: null
                    },
                    row: {
                        suggestions: [],
                        debounceMilliseconds: 500,
                        timeout: null,
                        currentIndex: '',
                    }
                },
                modals: {
                    'modal-orders-bills-edit-billing': {
                        active: 0
                    },
                    'modal-orders-bills-edit-shipping': {
                        active: 0
                    }
                },
                submitting: 0,
                pageKey: 1
            }
        },
        methods: {
            updateVendorConfirm() {
                if (this.vendorUpdated == 1) {
                    this.$bvModal.msgBoxConfirm('Vendor info updated. Would you like to update vendor data?', {
                            title: 'Save Bill',
                            size: 'sm',
                            buttonSize: 'sm',
                            okVariant: 'success',
                            okTitle: 'Yes',
                            cancelTitle: 'No',
                            footerClass: 'p-2',
                            hideHeaderClose: false,
                            centered: true
                    })
                    .then(value => {
                        if (value) {
                            this.create()
                        }
                    })
                    .catch(err => {
                        // An error occurred
                    })
                } else {
                    this.create()
                }
            },
            vendorChanged(action) {
                if (this.vendorReset == 0) {
                    this.vendorUpdated = action
                }
            },
            updateAddress(area, address) {
                this.$nextTick(() => {
                    this.datasets.core[area + 'Address'] = address
                    this.vendorChanged(1)
                })
            },
            nextRow(idx, col) {
                let target = col + 'input' + (idx + 1)
                if (col == 'sku') {
                    this.$refs[target][0].$el.childNodes[0].childNodes[0].childNodes[0].childNodes[0].focus()
                } else {
                    this.$refs[target][0].$el.focus()
                }
            },
            openModal(modalName, row, area) {
                let prefix = 'modal-orders-bills-'
                switch (modalName) {
                    case 'edit-shipping':
                        if (this.datasets.core.shippingAddressBlock) {
                            this.modals[prefix + modalName].active = 1
                        }
                        break;
                    case 'edit-billing':
                        if (this.datasets.core.billingAddressBlock) {
                            this.modals[prefix + modalName].active = 1
                        }
                        break;
                }
                this.$nextTick(() => {
                    this.$bvModal.show(prefix + modalName)
                })
            },
            closeModal(modalName) {
                this.$bvModal.hide(modalName)
            },
            toggleBusy() {
                this.tables.bills.isBusy = !this.tables.bills.isBusy
            },
            addTenRows() {
                for (var index = 0; index <= 10; index++) {
                    this.datasets.rows.push({sku: '', description: '', qty: '', rate: '', rateOriginal: '', amount: '', url: '', available: 0, mpn: ''})
                }
            },
            getPaymentTerms() {
                fetchActivePaymentTerms().then((terms) => {
                    this.datasets.paymentTerms = terms
                })
            },

            getShippingMethods() {
                fetchActiveShippingMethods().then((methods) => {
                    this.datasets.shippingMethods = methods
                })
            },

            getOrderTags() {
                let url = 'api/purchasing/bills/getordertags'
                axios.get(url, {})
                .then((res) => {
                    this.tags.list = res.data.tags
                }, () => {
                    this.has_error = true
                })
            },
            deleteRow(index) {
                let previousSkus = []
                this.datasets.rows.forEach((row, idx, array) => {
                    if (row.sku && idx != index) {
                        previousSkus.push(row.sku)
                    }
                })
                let target = 'skuinput' + (index + 1)
                if (this.datasets.rows.length == 1 && index == 0) {
                    this.datasets.rows[0].sku = ''
                    this.datasets.rows[0].description = ''
                    this.datasets.rows[0].qty = ''
                    this.datasets.rows[0].rate = ''
                    this.datasets.rows[0].rateOriginal = ''
                    this.datasets.rows[0].amount = ''
                    this.datasets.rows[0].url = ''
					this.datasets.rows[0].mpn = ''
                } else {
                    this.datasets.rows.splice(index, 1)
                }
                this.datasets.rows.forEach((row, idx, array) => {
                    if (row.sku) {
                        this.$refs['skuinput' + idx][0].$el.childNodes[0].childNodes[0].childNodes[0].childNodes[0].value = previousSkus[idx]
                        this.$refs['skuinput' + idx][0].query = row.sku
                    } else {
                        this.$refs['skuinput' + idx][0].$el.childNodes[0].childNodes[0].childNodes[0].childNodes[0].value = ''
                        this.$refs['skuinput' + idx][0].query = ''
                    }
                })
                this.calculateTotals()
            },
            qtyOrderedHasPositive() {
                let result = false
                let status = this.datasets.core.status
                return result
            },
            calculateRow(index) {
                let qty = this.datasets.rows[index].qty > 0 ? this.datasets.rows[index].qty : 0
                let qtyShipped = this.datasets.rows[index].qtyShipped > 0 ? this.datasets.rows[index].qtyShipped : 0
                let activeQty = this.qtyOrderedHasPositive() ? qtyShipped : qty
                // let rate = this.datasets.rows[index].rate ? this.datasets.rows[index].rate : 0
                let amount = 0
                amount = Number(activeQty) * this.datasets.rows[index].cost
                this.datasets.rows[index].amount = amount.toFixed(2)
                this.calculateTotals()
            },
            calculateTotals() {
                let subtotal = Number(0)
                this.datasets.rows.forEach((row, idx, array) => {
                    if (row.sku) {
                        let activeQty = this.qtyOrderedHasPositive() ? row.qtyShipped : row.qty
                        subtotal += row.cost * activeQty
                    }
                })
                this.datasets.core.subtotal = parseFloat(subtotal).toFixed(2)
                // this.datasets.rows.forEach((row, idx, array) => {
                //     let activeQty = this.qtyOrderedHasPositive() ? row.qtyShipped : row.qty
                // })
                let total = Number(0)
                this.datasets.core.total = parseFloat(subtotal + +this.datasets.core.shippingAmount - this.datasets.core.creditAmount).toFixed(2)
            },
            focusMeRow(index) {
                // this.autosuggest.row.currentIndex = index
                if (this.datasets.rows.length == index + 1) {
                    this.datasets.rows.push({sku: '', description: '', qty: '', rate: '', rateOriginal: '', amount: '', url: '', mpn: ''})
                    // this.autosuggest.row.suggestions.push([])
                    this.scrollToElement({behavior: 'smooth'}, index + 1)
                }
            },
            clickHandlerVendor(item) {
                let query = this.datasets.core.vendor
                if (!query) {
                    this.autosuggest.vendor.suggestions = []
                }
            },
            fetchResultsVendor() {
                const query = this.datasets.core.vendor
                clearTimeout(this.autosuggest.vendor.timeout);
                this.autosuggest.vendor.timeout = setTimeout(() => {
                    const vendorsPromise = axios.get('api/purchasing/bills/getvendorsdropdownsearch/' + query);
                    Promise.all([vendorsPromise]).then(values => {
                        this.autosuggest.vendor.suggestions = []
                        const vendors = values[0].data.vendors
                        vendors.length &&
                        this.autosuggest.vendor.suggestions.push({ name: "vendors", data: vendors })
                    })
                }, this.autosuggest.vendor.debounceMilliseconds)
            },
            fetchResultsRow() {
                const query = this.datasets.rows[this.autosuggest.row.currentIndex].sku
                clearTimeout(this.autosuggest.row.timeout);
                this.autosuggest.row.timeout = setTimeout(() => {
                    const productsPromise = axios.get('api/inventory/generatepicturefile/getproductsfilter/' + query);
                    Promise.all([productsPromise]).then(values => {
                        this.autosuggest.row.suggestions[this.autosuggest.row.currentIndex] = []
                        const products = values[0].data.items
                        products.length &&
                        this.autosuggest.row.suggestions[this.autosuggest.row.currentIndex].push({ name: "products", data: products })
                    })
                }, this.autosuggest.row.debounceMilliseconds)
            },
            onSelectedVendor(item) {
                if (item) {
                    this.vendorReset = 1
                    this.datasets.core.vendor = item.item.name
                    this.datasets.core.vendorId = item.item.id
                    this.datasets.core.email = item.item.email
                    this.datasets.core.phone = item.item.phone
                    this.datasets.core.fax = item.item.fax
                    this.datasets.core.billingAddress = item.item.billing
                    this.datasets.core.shippingAddress = item.item.shipping
                    this.datasets.core.shippingMethod = item.item.shipping_method
                    this.datasets.core.paymentTerm = item.item.payment_method
                    // this.datasets.core.buyer = item.item.buyer
                    this.datasets.core.internalNote = 'Vendor Notes: ' + item.item.notes
                    this.vendorReset = 0
                    this.pageKey++
                }
            },
            onSelectedRow(idx, sku, description, rate, url, qoh, cost, binA, binB, urlMed, available, mpn, lastCost, qoo) {
                this.datasets.rows[idx].sku = sku
                this.datasets.rows[idx].description = description
                this.datasets.rows[idx].rate = rate
                this.datasets.rows[idx].rateOriginal = rate
                this.datasets.rows[idx].url = url
                this.datasets.rows[idx].qoh = qoh
                this.datasets.rows[idx].cost = lastCost ? lastCost : cost
                this.datasets.rows[idx].available = available
				this.datasets.rows[idx].mpn = mpn
                this.datasets.rows[idx].lastCost = lastCost
                this.datasets.rows[idx].qoo = qoo
                this.calculateRow(idx)
            },
            onKeyTabVendor(evt) {
                let query = this.datasets.core.vendor.toLowerCase()
                setTimeout(() => {
                    if (this.autosuggest.vendor.suggestions.length) {
                        let results = this.autosuggest.vendor.suggestions[0].data
                        let resultName = results[0].name
                        if (resultName == query) {
                            this.vendorReset = 1
                            this.datasets.core.vendor = results[0].name
                            this.datasets.core.vendorId = results[0].id
                            this.datasets.core.email = results[0].email
                            this.datasets.core.phone = results[0].phone
                            this.datasets.core.fax = results[0].fax
                            this.datasets.core.billingAddress = results[0].billing
                            this.datasets.core.shippingAddress = results[0].shipping
                            this.datasets.core.shippingMethod = results[0].shipping_method
                            this.datasets.core.paymentTerm = results[0].payment_method
                            this.datasets.core.buyer = results[0].buyer
                            this.datasets.core.internalNote = 'Vendor Notes: ' + results[0].notes
                            this.autosuggest.vendor.suggestions = []
                            this.vendorReset = 0
                        } else {
                            this.autosuggest.vendor.suggestions = []
                        }
                    }
                }, 1500)
            },
            getSuggestionValueVendor(suggestion) {
                return suggestion.item.name
            },
            getSuggestionValueRow(suggestion) {
                return suggestion.item.name
            },
            suggestFirstVendor(query) {
                let suggests = this.autosuggest.vendor.suggestions
                let arr = suggests[0].data
                if (arr.length) {
                    for (var i = 0; i < arr.length; i++) {
                        let cur = arr[i].name.toLowerCase()
                        if (cur.includes(query.toLowerCase())) {
                            this.vendorReset = 1
                            this.datasets.core.vendor = arr[i].name
                            this.datasets.core.vendorId = arr[i].id
                            this.datasets.core.email = arr[i].email
                            this.datasets.core.phone = arr[i].phone
                            this.datasets.core.fax = arr[i].fax
                            this.datasets.core.billingAddress = arr[i].billing
                            this.datasets.core.shippingAddress = arr[i].shipping
                            this.autosuggest.vendor.suggestions = []
                            this.vendorReset = 0
                            break;
                        } else {
                            continue
                        }
                    }
                }
            },
            suggestFirstRow(idx, sku, description, rate, url, qoh, cost, available, mpn, lastCost, qoo) {
                this.datasets.rows[idx].sku = sku
                this.datasets.rows[idx].description = description
                this.datasets.rows[idx].rate = rate
                this.datasets.rows[idx].rateOriginal = rate
                this.datasets.rows[idx].url = url
                this.datasets.rows[idx].qoh = qoh
                this.datasets.rows[idx].cost = cost
                this.datasets.rows[idx].available = available
				this.datasets.rows[idx].mpn = mpn
                this.datasets.rows[idx].lastCost = lastCost
                this.datasets.rows[idx].qoo = qoo
                this.calculateRow(idx)
            },
            create() {
                this.submitting = 1
                let url = 'api/purchasing/bills/create'
                axios.post(url, {
                    core: this.datasets.core,
                    rows: this.datasets.rows,
                    updateVendor: this.vendorUpdated
                })
                .then((res) => {
                    this.submitting = 0
                    if (res.data.status == 'success') {
                        this.showAlertBox('success', 'Bill Created', 'Bill created successfully!')
                        this.$router.push({name: 'BillsDetail', params: { billNum: res.data.billsNum } })
                    } else {
                        this.showAlertBox('error', 'Error Creating Bill', res.data.status)
                    }
                }, () => {
                    this.has_error = true
                })
            },
            resetView() {
                this.datasets.rows = []
                for (var index = 0; index <= 2; index++) {
                    this.datasets.rows.push({sku: '', description: '', qty: '', rate: '', rateOriginal: '', amount: '', url: '', available: 0, mpn: ''})
                    this.autosuggest.row.suggestions.push([])
                }
                this.currentIndex = ''
            }
        },
    	computed: {
			filteredTags() {
                return this.tags.list.filter(i => {
                    return i.text.toLowerCase().indexOf(this.tags.currentTag.toLowerCase()) !== -1;
                })
            }
		},
        watch: {
            'datasets.core.shippingAddress': {
				handler(val) {
                    if (val) {
                        let shipping
                        if (val.shipping_address_1) { shipping = val.shipping_address_1; }
                        if (val.shipping_address_2) { shipping += "\r\n" + val.shipping_address_2; }
                        if (val.shipping_city) { shipping += "\r\n" + val.shipping_city; }
                        if (val.shipping_state) { shipping += ', ' + val.shipping_state; }
                        if (val.shipping_postal_code) { shipping += ' ' + val.shipping_postal_code; }
                        if (val.shipping_country) { shipping += "\r\n" + val.shipping_country; }
                        this.datasets.core.shippingAddressBlock = shipping
                    }
				},
                deep: true
            },
            'datasets.core.billingAddress': {
                handler(val) {
                    if (val) {
                        let billing
                        if (val.billing_address_1) { billing = val.billing_address_1; }
                        if (val.billing_address_2) { billing += "\r\n" + val.billing_address_2; }
                        if (val.billing_city) { billing += "\r\n" + val.billing_city; }
                        if (val.billing_state) { billing += ', ' + val.billing_state; }
                        if (val.billing_postal_code) { billing += ' ' + val.billing_postal_code; }
                        if (val.billing_country) { billing += "\r\n" + val.billing_country; }
                        this.datasets.core.billingAddressBlock = billing
                    }
				},
                deep: true
            }
        },
	    mounted() {
            this.getPaymentTerms()
            this.getShippingMethods()
            this.getOrderTags()
            this.datasets.locations = Object.keys(this.getLocations)

            this.resetView()

            this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
                switch (modalId) {
                    case 'modal-orders-bills-edit-shipping':
                        this.modals[modalId].active = 0
                        break
                    case 'modal-orders-bills-edit-billing':
                        this.modals[modalId].active = 0
                        break
                }
            })
	    }
  }
</script>
<style lang="scss">
    #bills-create {
		.table-totals-col {
            width: 20%;
        }
        .products-thumbs {
            max-width: 75px;
            max-height: 75px;
        }
        .th-number {
            width: 40px;
        }
        .vue-tags-input {
            max-width: 100%;
            .ti-input {
                display: block;
                width: auto;
                height: calc(1.2em + 0.75rem + 2px);
                // padding: 0.375rem 0.75rem;
                font-size: 1rem;
                font-weight: 400;
                line-height: 1.5;
                color: #495057;
                background-color: #fff;
                background-clip: padding-box;
                border: 1px solid #ced4da;
                border-radius: 0.25rem;
                transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
            }
        }
        .options-assign {
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
            input {
                width: 100%;
                padding: 0.5rem;
                height: calc(1.5em + 0.3rem + 2px);
            }
            ul {
                width: 100%;
                color: rgba(30, 39, 46,1.0);
                list-style: none;
                margin: 0;
                padding: 0.5rem 0 .5rem 0;
            }
            li {
                margin: 0 0 0 0;
                border-radius: 5px;
                padding: 0.75rem 0 0.75rem 0.75rem;
                display: flex;
                align-items: center;
            }
            li:hover {
                cursor: pointer;
            }
            .autosuggest-container {
                display: flex;
                // justify-content: center;
                width: 100%;
                li {
                    white-space: nowrap;
                    text-align: left;
                }
            }
            #autosuggest { width: 100%; display: block; }
            .autosuggest__results {
                position: relative;
            }
            .autosuggest__results-container {
                width: 300px;
            }
            .autosuggest__results-item--highlighted {
                background-color: rgba(51, 217, 178,0.2);
            }
            #autosuggest-autosuggest__results {
                overflow-y: hidden;
                // max-height: 200px;
            }
        }
    }
</style>
